import { ChildListingStatusEnum, ChildListingStepStatusEnum, ChildListingTypeEnum } from "cs.node.utils/csapi/provisioning";

export const listingTypeThemes = [
    {type: ChildListingTypeEnum.Full, variant: "primary", icon: "bi-upc"},
    {type: ChildListingTypeEnum.Price, variant: "danger", icon: "bi-tag"},
    {type: ChildListingTypeEnum.PriceQuantity, variant: "warning", icon: "bi-tags"},
    {type: ChildListingTypeEnum.Quantity, variant: "success", icon: "bi-stack"},
    {type: ChildListingTypeEnum.Remove, variant: "black", icon: "bi-trash"},
]

export const listingStatusThemes = [
    {status: ChildListingStatusEnum.Ready, variant: "black"},
    {status: ChildListingStatusEnum.Running, variant: "info"},
    {status: ChildListingStatusEnum.CompletedWarning, variant: "warning"},
    {status: ChildListingStatusEnum.Completed, variant: "success"},
    {status: ChildListingStatusEnum.Failed, variant: "danger"},
]

export const listingStepStatusThemes = [
    {status: ChildListingStepStatusEnum.Ignored, variant: "muted"},
    {status: ChildListingStepStatusEnum.Running, variant: "info"},
    {status: ChildListingStepStatusEnum.CompletedWarning, variant: "warning"},
    {status: ChildListingStepStatusEnum.Completed, variant: "success"},
    {status: ChildListingStepStatusEnum.Failed, variant: "danger"},
]

export const getListingTypeTheme = (listingType?: ChildListingTypeEnum) =>{
    return listingTypeThemes.find(theme=>theme.type === listingType)
}

export const getListingStatusTheme = (listingStatus?: ChildListingStatusEnum) =>{
    return listingStatusThemes.find(theme=>theme.status === listingStatus)
}

export const getListingStepStatusTheme = (listingStepStatus?: ChildListingStepStatusEnum) =>{
    return listingStepStatusThemes.find(theme=>theme.status === listingStepStatus)
}